<template>
  <vs-popup class="create-csutomer-crm-opportunity" id="popup"
    :title="isCreateMode ? `CREATE OPPORTUNITY PIPELINE` : `UPDATE OPPORTUNITY PIPELINE`" @close="open = false"
    :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-csutomer-crm-opportunity-popup" @submit.prevent="handleSubmit(onClickCreateSite)"
          autocomplete="off">


          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-1/2">
              <ValidationProvider vid="status" name="status" rules="required" v-slot="{ errors }">
                <small class="label">Opportunity Status</small>
                <v-select :disabled="!isCreateMode" :clearable="false" placeholder="" v-model="form.status"
                  :options="['MQL', 'SQL', 'Closed NIO']" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="w-full vx-col md:w-1/2">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Opportunity Name</small>
                <vs-input v-model="form.name" name="name" class="w-full" label="" :danger="!!errors[0]"
                  :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-1/2">
              <ValidationProvider vid="monetary_value" name="monetary_value" rules="" v-slot="{ errors }">
                <small class="label">Monetary Value (GBP)</small>
                <vs-input readonly v-model="form.monetary_value" name="monetary_value" class="w-full" label=""
                  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="w-full vx-col md:w-1/2 md:mb-0">
              <ValidationProvider vid="customer_users" name="customer_users" rules="" v-slot="{ errors }">
                <small class="label">Customer Users from System</small>
                <v-select name="timescale_type" :closeOnSelect="false" :clearable="false"
                  v-model="selected_customer_users_ids" :options="customer_users_list" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  :reduce="option => option.id" label="full_name" multiple />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row ml-1">
            <small class="label">New Customer Users (Full Name)</small>
          </div>

          <div class="mb-3 vx-row mt-2" v-for="(user, index) in selected_customer_users">
            <!-- <div class="w-full vx-col md:w-1/4 md:mb-0">
              <ValidationProvider :vid="`email_${index}`" :name="`email_${index}`" rules="required" v-slot="{ errors }">
                <small class="label">Email</small>
                <vs-input v-model="selected_customer_users[index].email" :name="`email_${index}`" class="w-full" label=""
                  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div> -->
            <div class="w-full vx-col md:w-3/4 md:mb-0">
              <ValidationProvider :vid="`full_name${index}`" :name="`full_name${index}`" rules="required"
                v-slot="{ errors }">
                <!-- <small class="label">Full Name</small> -->
                <vs-input v-model="selected_customer_users[index].full_name" :name="`full_name${index}`" class="w-full"
                  label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                  val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <!-- <div class="w-full vx-col md:w-1/4 md:mb-0">
              <ValidationProvider :vid="`last_name_${index}`" :name="`last_name_${index}`" rules="required"
                v-slot="{ errors }">
                <small class="label">Last Name</small>
                <vs-input v-model="selected_customer_users[index].last_name" :name="`last_name_${index}`" class="w-full"
                  label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                  val-icon-pack="feather" />
              </ValidationProvider>
            </div> -->
            <div class="w-full vx-col md:w-1/4 md:mb-0">
              <vs-button @click.stop="removeNewUser(index)" class="ml-3 w-full mt-6" size="small" color="danger"
                type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
            </div>
          </div>
          <vs-button @click="addNewUser" class="mt-2 ml-auto" size="small">Add new user</vs-button>


          <div class="mb-3 mt-8 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="staff" name="staff" rules="required" v-slot="{ errors }">
                <small class="label">ITS Staff Involved</small>
                <v-select name="timescale_type" :closeOnSelect="false" :clearable="false" v-model="form.staff"
                  :options="staffs" :dir="$vs.rtl ? 'rtl' : 'ltr'" :reduce="option => option.value" label="name"
                  multiple />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="source" name="source" rules="" v-slot="{ errors }">
                <small class="label">Source</small>
                <v-select multiple v-on:input="onChangeCustomerSource" :clearable="false" :closeOnSelect="false"
                  name="industry_sector" placeholder="" label="name" v-model="form.source" :reduce="option => option.id"
                  :options="customerSources" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{ option.name }} </span>
                  </template>
                </v-select>

                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="sub_source" name="sub_source" rules="" v-slot="{ errors }">
                <small class="label">Sub Source</small>
                <v-select multiple :clearable="false" :closeOnSelect="false" name="sub_source" placeholder="" label="name"
                  v-model="form.sub_source" :reduce="option => option.id" :options="customerSubSources"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{ option.name }} </span>
                  </template>
                  <template #no-options="{ search, searching, loading }">
                    Please select Industry Sector first!
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="project_briefs" name="project_briefs" rules="" v-slot="{ errors }">
                <small class="label">Project Brief</small>
                <v-select multiple :clearable="false" :closeOnSelect="false" name="project_briefs" placeholder=""
                  label="name" v-model="form.project_briefs" :reduce="option => option.id" :options="project_brief_list"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template slot="option" slot-scope="option">
                    <span>{{ option.name }} - {{ option.project_brief_code }}</span>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <span>{{ option.name }} - {{ option.project_brief_code }}</span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mt-8 mb-3" v-if="product_errors.length > 0">
            <div class="vx-col w-full">
              <vs-alert color="danger" class="h-16">
                There are {{ product_errors.length }} existing opprtunity/opprtunities with this product. <br>
                <span v-for="(error, index) in product_errors" :key="index"> {{ `${index + 1}. ${error.code}` }}</span>
              </vs-alert>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="products" name="products" rules="" v-slot="{ errors }">
                <small class="label">Products</small>
                <v-select multiple v-on:input="onChangeProduct" :clearable="false" :closeOnSelect="false" name="products"
                  placeholder="" label="name" v-model="form.products" :reduce="option => option.id"
                  :options="product_list" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template slot="option" slot-scope="option">
                    <span>{{ option.formulation_code }} - {{ option.name }}</span>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <span>{{ option.formulation_code }} - {{ option.name }}</span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="comment" name="comment" rules="max:5000" v-slot="{ errors }">
                <small class="label">Comment</small>
                <small class="label float-right text-warning font-bold">{{ form.comment.length }}/5000</small>
                <vs-textarea class="mb-0" v-model="form.comment" height="100px" />
                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="follow_up_date" name="follow_up_date" rules="required" v-slot="{ errors }">
                <small class="label">Follow Up Date</small>
                <flat-pickr :config="{ enableTime: true, dateFormat: 'd/m/Y' }" class="hidden"
                  v-model="form.follow_up_date" placeholder="Choose Date" />
                <flat-pickr :config="{ enableTime: false, dateFormat: 'd/m/Y' }" class="w-full"
                  v-model="form.follow_up_date" placeholder="Choose Date" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="follow_up_action" name="follow_up_action" rules="max:5000" v-slot="{ errors }">
                <small class="label">Follow-up Action</small>
                <small class="label float-right text-warning font-bold">{{ form.follow_up_action.length }}/5000</small>
                <vs-textarea class="mb-0" v-model="form.follow_up_action" height="100px" />
                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>


          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="notes" name="notes" rules="max:5000" v-slot="{ errors }">
                <small class="label">Notes</small>
                <small class="label float-right text-warning font-bold">{{ form.notes.length }}/5000</small>
                <vs-textarea class="mb-0" v-model="form.notes" height="100px" />
                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->


          <div class="vx-row">
            <div class="vx-col w-1/2">
              <span v-if="!isCreateMode">
                <h5 class="text-primary">Product Orders</h5>
                <span v-for="(order, index) in form.product_orders" :key="index">
                  <span class="mb-2">{{ order.product_order_code }}</span> <br>
                </span>
                <span v-if="form.product_orders.length === 0">N/A</span>
              </span>
            </div>
            <div class="vx-col w-1/2">
              <div class="flex flex-wrap items-center justify-end mt-8">
                <vs-button button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
                <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const DropDownRepository = RepositoryFactory.get('drop_down')
const CrmRepository = RepositoryFactory.get('crm')
const CustomerSourceRepository = RepositoryFactory.get('customer_source')

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

import vSelect from 'vue-select'

import { mapActions, mapGetters } from 'vuex';

function initialState() {
  return {
    open: false,
    id: '',
    form: {
      staff: [],
      name: '',
      notes: '',
      comment: '',
      follow_up_action: '',
      products: [],
      project_briefs: [],
      source: [],
      sub_source: [],
      monetary_value: 0,
      product_orders: []
    },
    isCreateMode: true,
    customer_users_list: [],
    selected_customer_users_ids: [],
    selected_customer_users: [],
    subjects_list: [],
    customerSources: [],
    customerSubSources: [],
    project_brief_list: [],
    product_list: [],
    product_errors: []
  }
}

export default {
  name: 'CreateCustomerCrmOpportunityPopUp',
  data() {
    return initialState()
  },
  props: {
    customer_id: {
      default: ''
    }
  },
  methods: {
    ...mapActions(['fetchStaffs']),
    async openPopup(id) {
      try {
        await Object.assign(this.$data, initialState());
        this.$refs.form.reset();
        this.open = true;
        await this.fetchCustomerUsers()
        await this.fetchCrmCustomerSubjects()
        await this.fetchStaffs()
        await this.loadCustomerSources()
        await this.fetchProjectBriefs()
        await this.fetchProducts()
        if (!!id) {
          this.id = id
          this.isCreateMode = false
          await this.fetchOpportunityDetails()
          await this.calculateMonetaryValue()
        } else {
          this.isCreateMode = true
        }
      } catch (error) {

      }
    },
    async fetchCustomerUsers() {
      try {
        const { data } = (await DropDownRepository.getCustomerUsersDropdownList(this.customer_id)).data
        this.customer_users_list = data
      } catch (error) {

      }
    },
    async fetchCrmCustomerSubjects() {
      try {
        const { data } = (await DropDownRepository.getCustomerCrmSubjectList()).data
        this.subjects_list = data
      } catch (error) {

      }
    },
    async fetchProjectBriefs() {
      try {
        const { data } = (await DropDownRepository.getProjectBriefDropDownList(`filter[customer_id]=${this.customer_id}`)).data
        this.project_brief_list = data
      } catch (error) {

      }
    },
    async fetchProducts() {
      try {
        const { data } = (await DropDownRepository.getFormulationList()).data
        this.product_list = data
      } catch (error) {

      }
    },
    async loadCustomerSources() {
      try {
        const { data } = (await CustomerSourceRepository.getListOfCustomerSource()).data
        this.customerSources = data
      } catch (error) {

      }
    },
    async onChangeCustomerSource(ids) {
      await this.$vs.loading();
      try {
        this.form.sub_source = []
        const { data } = (await CustomerSourceRepository.getCustomerSubSources({ ids: ids })).data
        this.customerSubSources = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close()
    },
    async onChangeProduct(row_data) {
      try {
        await this.calculateMonetaryValue()
        this.product_errors = []
        if (row_data.length === 0) return null
        const { data } = (await CrmRepository.checkProductsWithExistingOpportunity(this.customer_id, row_data[row_data.length - 1], this.id)).data
        this.product_errors = data
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    },
    async fetchOpportunityDetails() {
      await this.$vs.loading({
        container: '#create-csutomer-crm-opportunity-popup',
        scale: 0.45
      })
      try {
        const { data } = (await CrmRepository.getCustomerCrmOpportunity(this.id)).data
        this.form = data
        this.form.staff = data.staff.map((x) => x.id)
        this.selected_customer_users_ids = data.customer_users.filter((x) => !!x.id).map((x) => x.id)
        this.selected_customer_users = data.customer_users.filter((x) => !x.id)
        if (this.form.sub_source.length !== 0) {
          const { data } = (await CustomerSourceRepository.getCustomerSubSources({ ids: this.form.source })).data
          this.customerSubSources = data
        }
        this.form.products = this.form.products.map((x) => x.id)
        this.form.project_briefs = this.form.project_briefs.map((x) => x.id)
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-csutomer-crm-opportunity-popup > .con-vs-loading')
    },
    async onClickCreateSite() {
      const vue = this;
      await this.$vs.loading({
        container: '#create-csutomer-crm-opportunity-popup',
        scale: 0.45
      })
      try {
        const users_from_system = this.selected_customer_users_ids.map((x) => {
          const find = this.customer_users_list.find((y) => y.id === x)
          return { id: find.id, full_name: find.full_name }
        })
        this.form.customer_users = [...users_from_system, ...this.selected_customer_users.map((x) => ({ full_name: x.full_name }))]
        this.form.monetary_value = Number(this.form.monetary_value).toFixed(2)
        if (this.isCreateMode) {
          this.form.customer_id = this.customer_id
          await CrmRepository.createCustomerCrmOpportunity(this.form);
          this.showSuccessMessage('Customer crm opportunity added!');
        } else {
          delete this.form.status
          await CrmRepository.updateCustomerCrmOpportunity(this.id, this.form);
          this.showSuccessMessage('Customer crm opportunity updated!');
        }
        await vue.$parent.refreshData();
        this.open = false;
      } catch (e) {
        this.$vs.loading.close('#create-csutomer-crm-opportunity-popup > .con-vs-loading')
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-csutomer-crm-opportunity-popup > .con-vs-loading')
    },
    removeNewUser(index) {
      this.selected_customer_users.splice(index, 1)
    },
    addNewUser() {
      this.selected_customer_users.push({ full_name: '' })
    },
    async calculateMonetaryValue() {
      try {
        const payload = {
          'customer-id': this.customer_id,
          formulation: this.form.products
        }
        const { data } = (await CrmRepository.getOpportunityValueFromForecaseTool(payload)).data
        this.form.monetary_value = data.value
      } catch (error) {
        this.form.monetary_value = "0.00"
      }
    }
  },
  components: {
    flatPickr,
    'v-select': vSelect
  },
  computed: {
    ...mapGetters(['staffs'])
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.create-csutomer-crm-opportunity>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 40% !important;
}
</style>
